var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { attrs: { fluid: "", "grid-list-md": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticClass: "text-xs-right",
                  attrs: { xs12: "", "offset-sm6": "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.loadingExportData,
                        disabled: _vm.loadingExportData,
                        flat: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.download()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("exportInCsv")) +
                          "\n              "
                      ),
                      _c("v-icon", { attrs: { color: "primary", right: "" } }, [
                        _vm._v("file_download")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.oneStatHidden
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.loadingExportData,
                            disabled: _vm.loadingExportData,
                            flat: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.displayAllStats()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              voir toutes les stats\n              "
                          ),
                          _c(
                            "v-icon",
                            { attrs: { color: "primary", right: "" } },
                            [_vm._v("analytics")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md4: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _vm.loading
                        ? _c(
                            "v-card-text",
                            { staticClass: "text-xs-center pt-3" },
                            [
                              _c("v-progress-circular", {
                                staticClass: "primary--text",
                                attrs: { indeterminate: "" }
                              })
                            ],
                            1
                          )
                        : _c(
                            "v-container",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c("v-flex", { attrs: { xs12: "" } }, [
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "subheading text-xs-center"
                                        },
                                        [_vm._v("Conversations")]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "primary--text display-1 text-xs-center",
                                      attrs: { xs12: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.chatsOK) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md4: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _vm.loading
                        ? _c(
                            "v-card-text",
                            { staticClass: "text-xs-center pt-3" },
                            [
                              _c("v-progress-circular", {
                                staticClass: "primary--text",
                                attrs: { indeterminate: "" }
                              })
                            ],
                            1
                          )
                        : _c(
                            "v-container",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c("v-flex", { attrs: { xs12: "" } }, [
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "subheading text-xs-center"
                                        },
                                        [_vm._v("Durée moyenne")]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "primary--text display-1 text-xs-center",
                                      attrs: { xs12: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.averageDurationFormatted) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md4: "" } },
                [
                  _c(
                    "v-card",
                    [
                      _vm.loading
                        ? _c(
                            "v-card-text",
                            { staticClass: "text-xs-center pt-3" },
                            [
                              _c("v-progress-circular", {
                                staticClass: "primary--text",
                                attrs: { indeterminate: "" }
                              })
                            ],
                            1
                          )
                        : _c(
                            "v-container",
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c("v-flex", { attrs: { xs12: "" } }, [
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "subheading text-xs-center"
                                        },
                                        [_vm._v("Messages par conversation")]
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass:
                                        "primary--text display-1 text-xs-center",
                                      attrs: { xs12: "" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(_vm.nbMessages) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md4: "" } },
                [
                  _c("v-hover", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var hover = ref.hover
                          return _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              attrs: {
                                color: "grey lighten-4",
                                "max-width": "600",
                                height: "550"
                              }
                            },
                            [
                              _vm.loading
                                ? _c(
                                    "v-card-text",
                                    { staticClass: "text-xs-center pt-3" },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "primary--text",
                                        attrs: { indeterminate: "" }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "subheading text-xs-center"
                                                  },
                                                  [_vm._v("Chatbots consultés")]
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "primary--text display-1 text-xs-center",
                                              attrs: { xs12: "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                       " +
                                                  _vm._s(_vm.nbOpen) +
                                                  "\n                     "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-expand-transition", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "transition-fast-in-fast-out v-card--reveal text-xs",
                                            staticStyle: { height: "100%" }
                                          },
                                          [
                                            _vm.loading
                                              ? _c(
                                                  "v-card",
                                                  {
                                                    staticClass: "mb-3",
                                                    attrs: { height: "360px" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-card-text",
                                                      {
                                                        staticClass:
                                                          "text-xs-center pt-5"
                                                      },
                                                      [
                                                        _c(
                                                          "v-progress-circular",
                                                          {
                                                            staticClass:
                                                              "primary--text",
                                                            attrs: {
                                                              indeterminate: ""
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "v-card",
                                                  {
                                                    staticClass:
                                                      "mb-3 text-md-center",
                                                    attrs: { height: "360px" }
                                                  },
                                                  [
                                                    _c("highcharts", {
                                                      attrs: {
                                                        options:
                                                          _vm.graphOpening
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        "- Nb de visiteurs uniques l'ayant ouvert : " +
                                                          _vm._s(
                                                            _vm.nbDistinctOpen
                                                          )
                                                      )
                                                    ]),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        '- Nb total de questions posées (messages avec "?") : ' +
                                                          _vm._s(
                                                            _vm.nbQuestions
                                                          )
                                                      )
                                                    ]),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        '- Nb total de recherche (messages avec "cherche") : ' +
                                                          _vm._s(_vm.nbCherche)
                                                      )
                                                    ]),
                                                    _c("br")
                                                  ],
                                                  1
                                                )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _c(
                                "v-card-text",
                                {
                                  staticClass: "pt-0",
                                  staticStyle: { position: "relative" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-light grey--text mb-2"
                                    },
                                    [
                                      _vm._v(
                                        "C'est le nombre total des formulaires validés (ceux du volet latéral) + Prises de rendez vous + Rappels/callback, tous visiteurs confondus"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.isThereCarrousel
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c("v-hover", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var hover = ref.hover
                                return _c(
                                  "v-card",
                                  {
                                    staticClass: "mx-auto",
                                    attrs: {
                                      color: "grey lighten-4",
                                      "max-width": "600",
                                      height: "550"
                                    }
                                  },
                                  [
                                    _vm.loading
                                      ? _c(
                                          "v-card-text",
                                          {
                                            staticClass: "text-xs-center pt-3"
                                          },
                                          [
                                            _c("v-progress-circular", {
                                              staticClass: "primary--text",
                                              attrs: { indeterminate: "" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-container",
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "subheading text-xs-center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Carrousels proposés"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "primary--text display-1 text-xs-center",
                                                    attrs: { xs12: "" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                       " +
                                                        _vm._s(
                                                          _vm.nb_carousel
                                                        ) +
                                                        "\n                     "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-expand-transition", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "transition-fast-in-fast-out v-card--reveal text-xs",
                                                  staticStyle: {
                                                    height: "100%"
                                                  }
                                                },
                                                [
                                                  _c("highcharts", {
                                                    attrs: {
                                                      options:
                                                        _vm.jaugeCarousels
                                                    }
                                                  }),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "- Nb de visiteurs uniques ayant eu au moins un carrousel : " +
                                                        _vm._s(
                                                          _vm.nbVisWithCarrousel
                                                        )
                                                    )
                                                  ]),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      "- Nb moy. de carrousel par visiteur : " +
                                                        _vm._s(
                                                          _vm.nbCarouselsPerVis
                                                        )
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      {
                                        staticClass: "pt-0",
                                        staticStyle: { position: "relative" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-light grey--text mb-2"
                                          },
                                          [
                                            _vm._v(
                                              "C'est le nombre total de fois où le bot à montré un carrousel de résultats, tous visiteurs confondus"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          655280379
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isThereCTA
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c("v-hover", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var hover = ref.hover
                                return _c(
                                  "v-card",
                                  {
                                    staticClass: "mx-auto",
                                    attrs: {
                                      color: "grey lighten-4",
                                      "max-width": "600",
                                      height: "550"
                                    }
                                  },
                                  [
                                    _vm.loading
                                      ? _c(
                                          "v-card-text",
                                          {
                                            staticClass: "text-xs-center pt-3"
                                          },
                                          [
                                            _c("v-progress-circular", {
                                              staticClass: "primary--text",
                                              attrs: { indeterminate: "" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-container",
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "subheading text-xs-center"
                                                        },
                                                        [_vm._v("CTA cliqués")]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "primary--text display-1 text-xs-center",
                                                    attrs: { xs12: "" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                       " +
                                                        _vm._s(_vm.nb_cta) +
                                                        "\n                     "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-expand-transition", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "transition-fast-in-fast-out v-card--reveal text-xs",
                                                  staticStyle: {
                                                    height: "100%"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-card",
                                                    {
                                                      attrs: { height: "300" }
                                                    },
                                                    [
                                                      _c("highcharts", {
                                                        attrs: {
                                                          options:
                                                            _vm.optionsCta
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      {
                                        staticClass: "pt-0",
                                        staticStyle: { position: "relative" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-light grey--text mb-2"
                                          },
                                          [
                                            _vm._v(
                                              "C'est le nombre total de click sur les CTA : ceux présents sur les vignettes produits des carrousels (devis / brochure / panier ...), tous visiteurs confondus"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          162510559
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isThereTransfert
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c("v-hover", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var hover = ref.hover
                                return _c(
                                  "v-card",
                                  {
                                    staticClass: "mx-auto",
                                    attrs: {
                                      color: "grey lighten-4",
                                      "max-width": "600",
                                      height: "550"
                                    }
                                  },
                                  [
                                    _vm.loading
                                      ? _c(
                                          "v-card-text",
                                          {
                                            staticClass: "text-xs-center pt-3"
                                          },
                                          [
                                            _c("v-progress-circular", {
                                              staticClass: "primary--text",
                                              attrs: { indeterminate: "" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-container",
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "subheading text-xs-center"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Transferts multicanaux"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "primary--text display-1 text-xs-center",
                                                    attrs: { xs12: "" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                       " +
                                                        _vm._s(
                                                          _vm.nb_transferts
                                                        ) +
                                                        "\n                     "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-expand-transition", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "transition-fast-in-fast-out v-card--reveal text-xs",
                                                  staticStyle: {
                                                    height: "100%"
                                                  }
                                                },
                                                [
                                                  _vm.loading
                                                    ? _c(
                                                        "v-card",
                                                        {
                                                          staticClass: "mb-3",
                                                          attrs: {
                                                            height: "360px"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-text",
                                                            {
                                                              staticClass:
                                                                "text-xs-center pt-5"
                                                            },
                                                            [
                                                              _c(
                                                                "v-progress-circular",
                                                                {
                                                                  staticClass:
                                                                    "primary--text",
                                                                  attrs: {
                                                                    indeterminate:
                                                                      ""
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "v-card",
                                                        {
                                                          staticClass:
                                                            "mb-3 text-md-center",
                                                          attrs: {
                                                            height: "360px"
                                                          }
                                                        },
                                                        [
                                                          _c("highcharts", {
                                                            attrs: {
                                                              options:
                                                                _vm.graphTransfert
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "'Chat live' : " +
                                                                _vm._s(
                                                                  _vm.nb_transfertchat
                                                                )
                                                            )
                                                          ]),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "'Rappels/Callback' : " +
                                                                _vm._s(
                                                                  _vm.nb_transferttel
                                                                )
                                                            )
                                                          ]),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "'Formulaires de contact' : " +
                                                                _vm._s(
                                                                  _vm.nb_transfertemail
                                                                )
                                                            )
                                                          ]),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "'Prises de Rendez-vous' : " +
                                                                _vm._s(
                                                                  _vm.nb_transfertmeeting
                                                                ) +
                                                                " "
                                                            )
                                                          ]),
                                                          _c("br")
                                                        ],
                                                        1
                                                      )
                                                ],
                                                1
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      {
                                        staticClass: "pt-0",
                                        staticStyle: { position: "relative" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-light grey--text mb-2"
                                          },
                                          [
                                            _vm._v(
                                              "C'est le nombre total de click sur les boutons de transfert multicanal des bulles de chat (tous visiteurs confondus)"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          1559915846
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isThereConversion
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c("v-hover", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var hover = ref.hover
                                return _c(
                                  "v-card",
                                  {
                                    staticClass: "mx-auto",
                                    attrs: {
                                      color: "grey lighten-4",
                                      "max-width": "600",
                                      height: "550"
                                    }
                                  },
                                  [
                                    _vm.loading
                                      ? _c(
                                          "v-card-text",
                                          {
                                            staticClass: "text-xs-center pt-3"
                                          },
                                          [
                                            _c("v-progress-circular", {
                                              staticClass: "primary--text",
                                              attrs: { indeterminate: "" }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-container",
                                          [
                                            _c(
                                              "v-layout",
                                              { attrs: { row: "", wrap: "" } },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { xs12: "" } },
                                                  [
                                                    _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "subheading text-xs-center"
                                                        },
                                                        [_vm._v("Conversions")]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  {
                                                    staticClass:
                                                      "primary--text display-1 text-xs-center",
                                                    attrs: { xs12: "" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                       " +
                                                        _vm._s(
                                                          _vm.nb_formok +
                                                            _vm.nb_meetingok +
                                                            _vm.nb_c2cok
                                                        ) +
                                                        "\n                     "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-expand-transition", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "transition-fast-in-fast-out v-card--reveal text-xs",
                                                  staticStyle: {
                                                    height: "100%"
                                                  }
                                                },
                                                [
                                                  _vm.loading
                                                    ? _c(
                                                        "v-card",
                                                        {
                                                          staticClass: "mb-3",
                                                          attrs: {
                                                            height: "360px"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-card-text",
                                                            {
                                                              staticClass:
                                                                "text-xs-center pt-5"
                                                            },
                                                            [
                                                              _c(
                                                                "v-progress-circular",
                                                                {
                                                                  staticClass:
                                                                    "primary--text",
                                                                  attrs: {
                                                                    indeterminate:
                                                                      ""
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "v-card",
                                                        {
                                                          staticClass:
                                                            "mb-3 text-md-center",
                                                          attrs: {
                                                            height: "360px"
                                                          }
                                                        },
                                                        [
                                                          _c("highcharts", {
                                                            attrs: {
                                                              options:
                                                                _vm.graphConversion
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "- Nb de Callback effectués : " +
                                                                _vm._s(
                                                                  _vm.nb_c2cok
                                                                )
                                                            )
                                                          ]),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "- Nb de Meeting bookés : " +
                                                                _vm._s(
                                                                  _vm.nb_meetingok
                                                                )
                                                            )
                                                          ]),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              "- Nb de Formulaires validés : " +
                                                                _vm._s(
                                                                  _vm.nb_formok
                                                                )
                                                            )
                                                          ]),
                                                          _c("br")
                                                        ],
                                                        1
                                                      )
                                                ],
                                                1
                                              )
                                            ])
                                          ],
                                          1
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      {
                                        staticClass: "pt-0",
                                        staticStyle: { position: "relative" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-light grey--text mb-2"
                                          },
                                          [
                                            _vm._v(
                                              "C'est le nombre total des formulaires validés (ceux du volet latéral) + Prises de rendez vous + Rappels/callback, tous visiteurs confondus"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          1536905245
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isThereAccueil
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-hover",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var hover = ref.hover
                                  return _c(
                                    "v-card",
                                    {
                                      staticClass: "mx-auto",
                                      attrs: {
                                        color: "grey lighten-4",
                                        "max-width": "600",
                                        height: "550"
                                      }
                                    },
                                    [
                                      _vm.loading
                                        ? _c(
                                            "v-card-text",
                                            {
                                              staticClass: "text-xs-center pt-3"
                                            },
                                            [
                                              _c("v-progress-circular", {
                                                staticClass: "primary--text",
                                                attrs: { indeterminate: "" }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-container",
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "subheading text-xs-center"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Messages d'accueil cliqués"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "primary--text display-1 text-xs-center",
                                                      attrs: { xs12: "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                       " +
                                                          _vm._s(
                                                            _vm.nb_accueil
                                                          ) +
                                                          "\n                     "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-expand-transition", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "transition-fast-in-fast-out v-card--reveal text-xs",
                                                    staticStyle: {
                                                      height: "100%"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        attrs: { height: "300" }
                                                      },
                                                      [
                                                        _c("highcharts", {
                                                          attrs: {
                                                            options:
                                                              _vm.optionsAccueil
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        {
                                          staticClass: "pt-0",
                                          staticStyle: { position: "relative" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-light grey--text mb-2"
                                            },
                                            [
                                              _vm._v(
                                                "C'est le nombre total des messages d'exemple cliqués, tous visiteurs confondus"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            121023014
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm.nb_like > 0
                            ? _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs12: "",
                                        sm8: "",
                                        "offset-sm3": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _c(
                                            "v-list",
                                            {
                                              staticClass: "fixed-height-list",
                                              attrs: { dense: "" }
                                            },
                                            _vm._l(_vm.likesSessid, function(
                                              item
                                            ) {
                                              return _c(
                                                "v-list-tile",
                                                {
                                                  key: item,
                                                  on: {
                                                    click: function($event) {
                                                      _vm.dialogLike = true
                                                      _vm.editThisGuy = item
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v(_vm._s(item))
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            ripple: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "grey lighten-1"
                                                              }
                                                            },
                                                            [_vm._v("info")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isThereTop10
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", sm6: "", md4: "" } },
                    [
                      _c(
                        "v-hover",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var hover = ref.hover
                                  return _c(
                                    "v-card",
                                    {
                                      staticClass: "mx-auto",
                                      attrs: {
                                        color: "grey lighten-4",
                                        "max-width": "600",
                                        height: "550"
                                      }
                                    },
                                    [
                                      _vm.loading
                                        ? _c(
                                            "v-card-text",
                                            {
                                              staticClass: "text-xs-center pt-3"
                                            },
                                            [
                                              _c("v-progress-circular", {
                                                staticClass: "primary--text",
                                                attrs: { indeterminate: "" }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-container",
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "subheading text-xs-center"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Top 10 Produits consultés"
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass:
                                                        "primary--text display-1 text-xs-center",
                                                      attrs: { xs12: "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                       " +
                                                          _vm._s(
                                                            _vm.nb_products
                                                          ) +
                                                          "\n                     "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-expand-transition", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "transition-fast-in-fast-out v-card--reveal text-xs",
                                                    staticStyle: {
                                                      height: "100%"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-card",
                                                      {
                                                        attrs: { height: "300" }
                                                      },
                                                      [
                                                        _c("highcharts", {
                                                          attrs: {
                                                            options:
                                                              _vm.optionsTop10
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "v-card-text",
                                        {
                                          staticClass: "pt-0",
                                          staticStyle: { position: "relative" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "font-weight-light grey--text mb-2"
                                            },
                                            [
                                              _vm._v(
                                                "C'est le nombre total de pages produits qui ont été cliquées depuis les carrousels, et affichées dans le volet latéral, tous visiteurs confondus"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            2225866252
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm.nb_products > 0
                            ? _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        xs12: "",
                                        sm8: "",
                                        "offset-sm3": ""
                                      }
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _c(
                                            "v-list",
                                            {
                                              staticClass: "fixed-height-list",
                                              attrs: { dense: "" }
                                            },
                                            _vm._l(_vm.likesSessid, function(
                                              item
                                            ) {
                                              return _c(
                                                "v-list-tile",
                                                { key: item },
                                                [
                                                  _c(
                                                    "v-list-tile-content",
                                                    [
                                                      _c("v-list-tile-title", [
                                                        _vm._v(_vm._s(item))
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-list-tile-action",
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            ripple: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "grey lighten-1"
                                                              }
                                                            },
                                                            [_vm._v("info")]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md4: "" } },
                [
                  _c("v-hover", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var hover = ref.hover
                          return _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              attrs: {
                                color: "grey lighten-4",
                                "max-width": "600",
                                height: "550"
                              }
                            },
                            [
                              _vm.loading
                                ? _c(
                                    "v-card-text",
                                    { staticClass: "text-xs-center pt-3" },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "primary--text",
                                        attrs: { indeterminate: "" }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "subheading text-xs-center"
                                                  },
                                                  [_vm._v("Nb de like 👍")]
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "primary--text display-1 text-xs-center",
                                              attrs: { xs12: "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.nb_like) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.nb_like > 0
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { xs12: "", sm12: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-card",
                                                    [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          staticClass:
                                                            "fixed-height-list",
                                                          attrs: { dense: "" }
                                                        },
                                                        _vm._l(
                                                          _vm.likesSessid,
                                                          function(item) {
                                                            return _c(
                                                              "v-list-tile",
                                                              {
                                                                key: item,
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.dialogLike = true
                                                                    _vm.editThisGuy = item
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-tile-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-tile-title",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list-tile-action",
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "",
                                                                          ripple:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "grey lighten-1"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "info"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm6: "", md4: "" } },
                [
                  _c("v-hover", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var hover = ref.hover
                          return _c(
                            "v-card",
                            {
                              staticClass: "mx-auto",
                              attrs: {
                                color: "grey lighten-4",
                                "max-width": "600",
                                height: "550"
                              }
                            },
                            [
                              _vm.loading
                                ? _c(
                                    "v-card-text",
                                    { staticClass: "text-xs-center pt-3" },
                                    [
                                      _c("v-progress-circular", {
                                        staticClass: "primary--text",
                                        attrs: { indeterminate: "" }
                                      })
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "subheading text-xs-center"
                                                  },
                                                  [_vm._v("Nb de unlike 👎")]
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass:
                                                "primary--text display-1 text-xs-center",
                                              attrs: { xs12: "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.nb_unlike) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.nb_unlike > 0
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { xs12: "", sm12: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-card",
                                                    [
                                                      _c(
                                                        "v-list",
                                                        {
                                                          staticClass:
                                                            "fixed-height-list",
                                                          attrs: { dense: "" }
                                                        },
                                                        _vm._l(
                                                          _vm.unlikesSessid,
                                                          function(item) {
                                                            return _c(
                                                              "v-list-tile",
                                                              {
                                                                key: item,
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.dialogLike = true
                                                                    _vm.editThisGuy = item
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-tile-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-tile-title",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item
                                                                          )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-list-tile-action",
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "",
                                                                          ripple:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "grey lighten-1"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "info"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            [
              !_vm.histoready
                ? _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "accent" },
                      on: {
                        click: function($event) {
                          return _vm.filterShortChats()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            Afficher les conversations riches (> 1 message)\n            "
                      ),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("filter_alt")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.histoready
                ? _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "accent" },
                      on: {
                        click: function($event) {
                          return _vm.showChats()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("hideChat")) +
                          "\n            "
                      ),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("visibility_off")
                      ])
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "accent" },
                      on: {
                        click: function($event) {
                          return _vm.getChats()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n             Afficher toutes les conversations\n            "
                      ),
                      _c("v-icon", { attrs: { right: "" } }, [
                        _vm._v("visibility")
                      ])
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _vm.histoready
            ? _c("wz-histo-chats", {
                attrs: {
                  params: _vm.params,
                  numChatsTotal: String(_vm.chatsOK),
                  filterChats: _vm.filterChats
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "1200px",
            scrollable: !_vm.$vuetify.breakpoint.smAndDown,
            fullscreen: _vm.$vuetify.breakpoint.smAndDown
          },
          model: {
            value: _vm.dialogLike,
            callback: function($$v) {
              _vm.dialogLike = $$v
            },
            expression: "dialogLike"
          }
        },
        [
          _c(
            "v-card-text",
            {
              staticClass: "pa-0",
              style: !_vm.$vuetify.breakpoint.smAndDown
                ? "height: calc(100vh - 210px);"
                : ""
            },
            [
              _vm.editThisGuy !== ""
                ? _c("wz-histo-chats", {
                    attrs: {
                      params: "visId=" + _vm.editThisGuy,
                      numChatsTotal: String(0),
                      chatHeight: "100%",
                      type: "satisfaction",
                      scroll: ""
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3e2ae32", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3e2ae32","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/ChatbotAI.vue
// module id = null
// module chunks = 